import { Typography } from '@mui/material';

import { INavMenuItemProps } from 'interfaces/PreviewScreen/previewScreen';

const NavMenuItem = ({
  isMediaMax1025px,
  setActive,
  image,
  navName,
  active,
  canLock,
  signalNewMessage,
  setSignalNewMessage,
}: INavMenuItemProps) => {
  const imageSource = image.main;
  const navDisplayName = navName;
  let navTextStyle = { color: 'black' };

  if (navName === 'Lock') {
    navTextStyle = { color: canLock ? 'black' : 'grey' };
  }
  const handleChatClick = () => {
    if (navName === 'About') {
      window.open('https://fileverse.io', '_blank', 'noopener');
      return;
    }
    if (active === 'Chat' || navName === 'Chat') {
      setSignalNewMessage(false);
    }
    setActive(navName);
  };
  return (
    <div
      className={`relative rounded-lg ${
        active === navName ? 'bg-yellow' : 'bg-white border border-black '
      } w-[100%] mr-2 flex justify-center items-center text-1 font-medium cursor-pointer 
      }`}
      onClick={handleChatClick}
    >
      <span className="relative">
        <img
          className={isMediaMax1025px ? 'mr-1' : 'mr-2'}
          src={imageSource}
          alt=""
        />
        {navName === 'Chat' && active !== 'Chat' && signalNewMessage && (
          <div
            className={`bg-red w-2 h-2 ml-2 absolute top-[-3px] left-[-11px] rounded-full`}
          >
            {' '}
          </div>
        )}
      </span>
      <Typography style={navTextStyle}>{navDisplayName}</Typography>
    </div>
  );
};

export default NavMenuItem;
